var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card, useTheme } from '@mui/material';
import _ from 'lodash';
export var translateLabel = function (obj, t) {
    var rs = __assign(__assign({}, obj), { label: t(obj.label) });
    if (obj.icon) {
        rs = __assign(__assign({}, rs), { icon: "".concat(process.env.DOMAIN, "/images/icons/").concat(obj.icon) });
    }
    return rs;
};
export var translateNestedArrays = function (obj, t) {
    var rs = translateLabel(obj, t);
    if (_.isArray(obj.items)) {
        rs = __assign(__assign({}, rs), { items: obj.items.map(function (item) { return translateNestedArrays(item, t); }) });
    }
    if (_.isArray(obj.children)) {
        rs = __assign(__assign({}, rs), { children: obj.children.map(function (child) {
                return translateNestedArrays(child, t);
            }) });
    }
    return rs;
};
var Container = function (_a) {
    var children = _a.children;
    var theme = useTheme();
    return (_jsx(Card, { sx: {
            border: "1px solid ".concat(theme.palette.border.container),
            borderRadius: '16px',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            bgcolor: theme.palette.background.default,
            boxShadow: 'none',
        }, children: children }));
};
export default Container;
